import { render, staticRenderFns } from "./Doughnut-Chart.vue?vue&type=template&id=4faf4026&scoped=true"
import script from "./Doughnut-Chart.vue?vue&type=script&lang=js"
export * from "./Doughnut-Chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faf4026",
  null
  
)

export default component.exports